module.exports = "/assets/images/lock_93c0d4.svg";